import { openBlock as e, createElementBlock as l, createElementVNode as t } from "vue";
const o = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, c = /* @__PURE__ */ t("path", {
  "fill-rule": "evenodd",
  d: "m12 5.339-.022.01-8.3 4.151 8.3 4.15.022.011.022-.01 8.301-4.15-8.3-4.151L12 5.339Zm-.23-1.508a1.25 1.25 0 0 1 .46 0 1.65 1.65 0 0 1 .463.177l9.643 4.821a.75.75 0 0 1 0 1.342l-9.643 4.821-.027.014c-.097.05-.257.13-.436.164a1.25 1.25 0 0 1-.46 0 1.649 1.649 0 0 1-.436-.164l-.027-.014-9.642-4.821a.75.75 0 0 1 0-1.342l9.642-4.82.027-.015c.097-.049.257-.13.436-.163ZM1.33 13.165a.75.75 0 0 1 1.005-.336l9.643 4.821.022.012.022-.012 9.643-4.82a.75.75 0 0 1 .67 1.34l-9.642 4.822-.027.014c-.097.05-.257.13-.436.164a1.25 1.25 0 0 1-.46 0 1.649 1.649 0 0 1-.436-.164l-.027-.014-9.642-4.821a.75.75 0 0 1-.336-1.006Z",
  "clip-rule": "evenodd"
}, null, -1), n = [
  c
];
function a(r, d) {
  return e(), l("svg", o, [...n]);
}
const i = { render: a };
export {
  i as default,
  a as render
};
